export const BIRD_X = 44;
export const BIRD_WIDTH = 22;
export const BIRD_HEIGHT = 18;
export const PIPE_WIDTH = 30;
const SPEED = 48;
const SPACING = 144;

const makePipe = (id, x, height, random) => {
  const gap = height * 0.55;
  return { id, x, top: 16 + random() * (height - gap - 32), gap, passed: false };
};

export function createFlight(width, height, random = Math.random) {
  return {
    y: (height - BIRD_HEIGHT) / 2, velocity: 0, score: 0,
    flying: false, ended: false, nextId: 1,
    pipes: [makePipe(0, width + 64, height, random)],
  };
}

export function flap(flight) {
  return flight.ended ? flight : { ...flight, flying: true, velocity: -120 };
}

export function stepFlight(flight, dt, width, height, random = Math.random) {
  // Hover until the first tap. Starting a round never drops an unsuspecting bird.
  if (!flight.flying || flight.ended) return flight;
  const seconds = Math.min(0.05, Math.max(0, dt));
  const velocity = flight.velocity + 360 * seconds;
  const y = flight.y + velocity * seconds;
  let score = flight.score;
  const pipes = flight.pipes.map(pipe => {
    const x = pipe.x - SPEED * seconds;
    const passed = pipe.passed || x + PIPE_WIDTH < BIRD_X;
    if (passed && !pipe.passed) score += 1;
    return { ...pipe, x, passed };
  }).filter(pipe => pipe.x > -PIPE_WIDTH);
  let nextId = flight.nextId;
  const last = pipes[pipes.length - 1];
  if (!last || last.x < width - SPACING + 64) {
    pipes.push(makePipe(nextId++, last ? last.x + SPACING : width + 64, height, random));
  }
  const ended = y < 0 || y + BIRD_HEIGHT > height || pipes.some(pipe => (
    BIRD_X + BIRD_WIDTH > pipe.x && BIRD_X < pipe.x + PIPE_WIDTH
    && (y < pipe.top || y + BIRD_HEIGHT > pipe.top + pipe.gap)
  ));
  return { ...flight, y, velocity, score, pipes, nextId, ended };
}
